<template>
  <Modal title="Добавить аксессуары" :is-show="isShow" @close="close">
    <form class="form" @submit.prevent="submit">
      <div class="accessoriesList">
        <div class="accessoriesList-item">
          <div class="accessoriesList-value">
            <Checkbox
              :value="form.back_screen"
              @input="form.back_screen = $event; form.back_screen_count = ($event ? 1 : 0) "
              :disabled="!canBackScreen"
              hint="Возможно только для секций с шириной:
              900/1200/1500/1800/2100"
            >
              Задний экран
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="number" v-model="form.back_screen_count"> шт
          </div>
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item" v-if="separate">
          <div class="accessoriesList-value">
            <Checkbox
              :value="form.side_screen"
              @input="form.side_screen = $event; form.side_screen_count = ($event ? 1 : 0) "
              :disabled="!canSideScreen"
              hint="Боковые экраны можно добавить только на 
              секции с глубинами 600/800/1000

              Экранов в комплекте 2 штуки: правый и левый."
            >
              Боковой экран
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="number" v-model="form.side_screen_count"> комп.
          </div>
        </div><!-- .accessoriesList-item -->
      </div><!-- .accessoriesList -->

      <div class="field">
        <button
          type="submit"
          class="btn"
        >
          <span>Применить</span>
        </button>
        <button
          type="button"
          class="btn btn-white"
          @click="close"
        >
          <span>Отмена</span>
        </button>
      </div>

      <div class="hint">
        Изображение аксессуаров на схеме схематичное. Количество выбранных аксессуаров может не совпадать с количеством изображенных.
      </div>
    </form>
  </Modal>
</template>

<script>
  import Modal from './Modal.vue';
  import Checkbox from './Checkbox2.vue';

  export default {
    components: {
      Modal,
      Checkbox,
    },
    props: {
      isShow: Boolean,
      separate: Boolean,
      canBackScreen: {
        type: Boolean,
        default: false,
      },
      canSideScreen: {
        type: Boolean,
        default: false,
      },
      count: {
        type: Number,
        default: 3,
      },
      value: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        form: {
          back_screen: false,
          back_screen_count: 1,
          side_screen: false,
          side_screen_count: 1,
        },
      };
    },
    mounted() {
      this.form = Object.assign({}, this.form, this.value);
    },
    methods: {
      close() {
        this.$emit('close');
      },
      submit() {
        this.$emit('input', this.form);
        this.$emit('close');
      },
    },
  };
</script>

<style>
  .rowItem .form button { width: auto; }
  .form button {
    width: auto;
    cursor: pointer;
  }
  .form button + button { margin-left: 20px; }
  .form button.btn-white {
    background-color: transparent;
    color: #F58214;
    border: 2px solid #F58214;
  }
  .accessoriesList {
    margin-bottom: 40px;
    font-size: 14px;
  }
  .accessoriesList a {
    text-decoration: none;
    color: #0B53B3;
  }
  .accessoriesList-item {
    display: flex;
    padding: 16px 0;
    border-top: 1px solid #DDDDDD;
    border-bottom: 1px solid #DDDDDD;
  }
  .accessoriesList-item + .accessoriesList-item {
    border-top: none;
  }
  .accessoriesList-value {
    flex-grow: 1;
    margin-right: 23px;
  }
  .accessoriesList-image {
    width: 48px;
    margin-right: 23px;
  }
  .accessoriesList-count {
    width: 190px;
  }
  .accessoriesList-count input {
    margin: 0 9px;
    width: 47px;
    height: 32px;
    text-align: center;
    background: white;
    border: 1px solid #CECECE;
    appearance: textfield;
  }
  .hint {
    margin-top: 22px;
    width: 644px;
    font-size: 14px;
    color: #A7A7A7;
  }
</style>
